import useSWR from 'swr'
import { useTranslation } from 'react-i18next'
import { paths } from 'routes/paths'
import tagRanking from 'api/courses/tag_ranking'
import Loader from 'components/ui/loader/Loader'
import { Folder } from '../Folder'

export const Recommended = ({ search }: { search: string }) => {
  const { t } = useTranslation()
  const { data, isLoading } = useSWR(
    { key: 'recommended', search },
    async (arg) =>
      tagRanking({
        page: 1,
        perPage: 8,
        search: arg.search,
      })
  )

  const courses = (data?.courses || []).map(({ course }) => ({
    course,
    enrol: null,
  }))

  return (
    <div>
      {isLoading && <Loader color />}
      {!!courses.length && (
        <Folder
          href={paths.home.recommended}
          name={t('newhome.sections.recommendedCourses.title')}
          courses={courses}
          totalCourses={data?.total || 0}
        />
      )}
    </div>
  )
}

export default Recommended
